import { render, staticRenderFns } from "./PrevAgent.vue?vue&type=template&id=cf18fbbc&scoped=true"
import script from "./PrevAgent.vue?vue&type=script&lang=js"
export * from "./PrevAgent.vue?vue&type=script&lang=js"
import style0 from "./PrevAgent.vue?vue&type=style&index=0&id=cf18fbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf18fbbc",
  null
  
)

export default component.exports